export default __webpack_public_path__ + "media/images/40-3d5c00b0e009d932b4db3131795f0bf0.jpg";